import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { MarkdownModule } from 'ngx-markdown';
import { MatExpansionModule } from '@angular/material/expansion';

import { RestapiService } from '@services/restapi.service';
interface FAQItem {
  title: string;
  sections: {
    subheading: string;
    content: string;
  }[];
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, MarkdownModule, MatExpansionModule],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  list: any[] = [];
  panelOpenState = false;
  list1: any;
  heading1: any;
  heading2: any;
  jsonArray: any;

  constructor(
    private restAPI: RestapiService
  ) {}

  ngOnInit(): void {
    this.subscription = this.restAPI.getS3FileAPI('landingPage/landingPage-faq.md').subscribe(data => {
      const faqList: FAQItem[] = [];

      const lines = data.split('\n');
      let currentFAQ: FAQItem | null = null;
      let currentSection: { subheading: string; content: string } | null = null;

      for (const line of lines) {
        if (line.startsWith('#### ')) {
          // New FAQ item
          if (currentFAQ !== null) {
            faqList.push(currentFAQ);
          }
          currentFAQ = {
            title: line.replace('#### ', '').trim(),
            sections: [],
          };
          currentSection = null;
        } else if (line.startsWith('**')) {
          // New subheading

          const relpacEStart = line.replace('**', '').trim()
          currentSection = {
            subheading: relpacEStart.replace('**', '').trim(),
            content: '',
          };
          if (currentFAQ !== null && currentSection !== null) {
            currentFAQ.sections.push(currentSection);
          }
        } else {
          currentSection = {
            subheading: '',
            content: line,
          };

          if (currentFAQ !== null && currentSection !== null) {
            currentFAQ.sections.push(currentSection);
          }
        }
      }

      // Push the last FAQ item (if any)
      if (currentFAQ !== null) {
        faqList.push(currentFAQ);
      }

      // Convert to JSON and print
      const jsonOutput = JSON.stringify(faqList, null, 2);

      this.jsonArray = JSON.parse(jsonOutput)
    }

    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

